import { render, staticRenderFns } from "./MyQuizzesBoardView.vue?vue&type=template&id=38bdb539&scoped=true&"
import script from "./MyQuizzesBoardView.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesBoardView.vue?vue&type=script&lang=js&"
import style0 from "./MyQuizzesBoardView.vue?vue&type=style&index=0&id=38bdb539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bdb539",
  null
  
)

export default component.exports